import React, { Component } from 'react';
import { T } from '../../../../src/Components/FeatureComponents/Response/Utils';
import ModalPane from './ModalPane';
import List from '../ChatInput/List';
import LangConfirmation from '../LangConfirmation';

interface Props {
	language1: any;
	langcodes: any;
	changeLang: Function;
	currentLang: string;
	onClose: Function;
	showLangConfirmation: boolean;
	toLang: string;
	onConfirm: Function;
	detailedLanguages?: any;
}
interface State {
	lang: string;
	sortedlangs: any;
	selectedLang: string;
	selectedLangCode: string;
}

class LangModal extends Component<Props, State> {
	constructor(props) {
		super(props);

		this.state = {
			lang: this.props.language1,
			sortedlangs: [],
			selectedLang: this.props.langcodes[this.props.currentLang],
			selectedLangCode: this.props.currentLang,
		};
	}

	componentDidMount() {
		let codes = this.state.lang;
		codes = 'en' + ',' + codes;
		let splititems = codes.split(',');
		let listcodes = [];
		for (let i = 0; i < splititems.length; i++) {
			if (this.props.langcodes[splititems[i]])
				listcodes.push(this.props.langcodes[splititems[i]]);
		}
		// for (const property in this.props.langcodes) {
		//   if (
		//     splititems.includes(property) &&
		//     this.props.langcodes[property] !== null
		//   ) {
		// listcodes.push(this.props.langcodes[property]);
		//   }
		// }
		const index = listcodes.indexOf('English');
		listcodes.splice(index, 1);
		listcodes.unshift('English');
		this.setState({
			sortedlangs: listcodes,
		});
		setTimeout(() => {
			var el = document.querySelector('.modal-title');
			el && (el as HTMLElement).focus();
		}, 100);
	}
	selectlang = (lang) => {
		let onSelectLang = lang
			? lang
			: this.props.langcodes[this.props.currentLang];

		for (const property in this.props.langcodes) {
			if (this.props.langcodes[property] === onSelectLang) {
				this.setState({
					selectedLangCode: property,
					selectedLang: onSelectLang,
				});
			}
		}
	};
	updateLang = () => {
		this.props.changeLang(this.state.selectedLangCode);
		if (this.state.selectedLangCode === this.props.currentLang) {
			this.props.onClose(true);
		}
	};
	render() {
		return (
			<>
				{this.props.showLangConfirmation ? (
					<LangConfirmation
						toLang={this.props.toLang}
						onClose={() => this.props.onClose(true)}
						onConfirm={() => this.props.onConfirm()}
					/>
				) : (
					<ModalPane
						heading={
							<T
								langCode={this.state.selectedLangCode}
								labelName='selectLanguageLabel'
							/>
						}
						buttons={[
							{
								label: (
									<T
										langCode={this.state.selectedLangCode}
										labelName='continueLabel'
									/>
								),
								onClick: () => {
									this.updateLang();
								},
							},
						]}
						onClose={() => {
							this.props.onClose(true);
						}}
					>
						<List
							items={this.state.sortedlangs}
							type={'modal'}
							onPress={this.selectlang}
							dataItem={
								this.state.selectedLang
									? this.state.selectedLang
									: this.props.langcodes[this.props.currentLang]
							}
						/>
					</ModalPane>
				)}
			</>
		);
	}
}

export default LangModal;
